// The improved version of the My Intrivity Application
import { html, css, LitElement, unsafeCSS } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core"; 
import { getFunctions, httpsCallable } from 'firebase/functions';
import { loadStripe } from "@stripe/stripe-js";

import { doc, setDoc, getDoc, getDocs, collection, collectionGroup, query, where, addDoc, getFirestore } from "firebase/firestore";
 
import { functions } from './intrivity_app.js';
import './badge.js';
import './user_profile_field_editor_app.js';
import '@material/mwc-dialog';

import { db, user } from './intrivity_app.js';
import { 
    emitEvent, getScore, INTRIVITY_LOAD_GROUPS, INTRIVITY_STRIPE_PUBLIC_KEY
} from './utility.js'
import { a11yStyles } from './a11y.js';
import { t, Localized, formatNumber } from './i18n.js';

import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';

const stripePromise = loadStripe(INTRIVITY_STRIPE_PUBLIC_KEY);

export class IntrivityUserApp extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            .user_layout {
                display: grid;
                grid-template-columns: 1fr 4fr 1fr;
                grid-gap: 5px;
                margin-top: 30px;
            }
            .user_field {
                color: #424141;
                font-size: 2.0vmax;
                margin-bottom: 20px;
            }
            .user_edit {
                cursor: pointer;
                color: #424141;
                white-space: nowrap; 
                margin-left: 10px; 
                font-size: 0.8vmax;
            }
            .user_config {
                color: #424141;
                margin: 20px;
                padding: 20px;
                grid-column: 1 / span 3;
                background-color: #F6F6F6;
                font-size: 1.5vmax;
             
            }
            .user_comparisons {
                font-size: 1.5vmax;
                margin-left: 60px;
                margin-bottom: 20px;
            }
        `];
    }
    
    static get properties() {
        return {
            user_profile: { type: Object },
            report: { type: Object },
            group_code: { type: String },
            group_reports: { type: Array },
            group: { type: Object },
            display_group: { type: Object },
            started_payment: { type: Boolean }
        };
    }

    connectedCallback() {
        super.connectedCallback();
        //window.addEventListener("resize", (e)=> { this.requestUpdate(); });
        //console.log("IntrivityUser loaded. Emit load groups event.");
        //emitEvent( INTRIVITY_LOAD_GROUPS, {}, this );
        
    }
    
    async firstUpdated() {
        //emitEvent( INTRIVITY_LOAD_GROUPS, {}, this );
        if (!this.group && this.user_profile && this.user_profile.group && !this.user_profile.paid) {
            const docRef = doc(db, "groups", this.user_profile.group);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                this.group = docSnap.data(); 
            }   
        }   
    }
    
    constructor() {
        super(); 
        this.getRegistrationGroup = this.getRegistrationGroup.bind(this);
        this.sendToSurvey = this.sendToSurvey.bind(this);
        this.gotoPayment = this.gotoPayment.bind(this);
    }

    async sendToSurvey() {
        // https://www.research.net/r/LWV5WDJ?userid=joseph.conder@gmail.com&groupid=hwCXbf1U9mmWvdyQ1pEI
        if (this.user_profile.group) {
            if (!this.group) {
                const docRef = doc(db, "groups", this.user_profile.group);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    this.group = docSnap.data(); 
                }   
            }
            if (this.group) {
                if (confirm(t('account.confirmSurvey'))) {
                    let url = 'https://www.research.net/r/';
                    url += this.group.survey_monkey_key;
                    url += '?userid=';
                    url += user.email;
                    url += '&groupid=';
                    url += this.user_profile.group;
                    window.location.href = url;
                }
            }
        }
    }
    
    // Redeem a personal invitation code on the server, then reload the
    // profile it changed so later whole-profile writes don't undo it.
    async claimInvitationCode(code) {
        if (!this.user_profile.email) this.user_profile.email = user.email;
        const claimInvitation = httpsCallable(functions, 'claimInvitation');
        await claimInvitation({ code, email: this.user_profile.email });
        const snap = await getDoc(doc(db, "users", this.user_profile.email));
        if (snap.exists()) Object.assign(this.user_profile, snap.data());
        this.requestUpdate();
    }

    claimErrorMessage(err) {
        const code = err && err.code;
        if (code === 'functions/already-exists') return t('account.codeClaimed');
        if (code === 'functions/not-found') return t('account.codeNoMatch');
        return t('account.joinFailed');
    }

    async getAdditionalGroup() {
        if (!this.user_profile.email) this.user_profile.email = user.email;
console.log("get add group " + this.group_code);
        let groupx = undefined;
        // Get the invitation from code
        const invitationQuery = query(collectionGroup(db, 'invitations'), where("code", "==", this.group_code));
        const invitationSnapshot = await getDocs(invitationQuery);
        let invitation = {};
        // An invitation was found
        if (invitationSnapshot.size > 0) {
console.log("invitation found ");
            // this is getting the last invitation
            invitationSnapshot.forEach((invDoc) => {
                console.log(invDoc.id, ' => ', invDoc.data());
                invitation = invDoc.data();
            });
console.log(invitation);
            if (invitation.status && invitation.status == "claimed") {
                alert(t('account.codeClaimed'));
            } else {
                // Get the group for the invitation
                if (invitation.group_uuid) {
                    const groupRef = doc(db, "groups", invitation.group_uuid);
                    const groupSnap = await getDoc(groupRef);
                    if (groupSnap.exists()) {
                        console.log(groupSnap.id, ' => ', groupSnap.data());
                        groupx = groupSnap.data();
console.log(groupx);
                    } else {
                        alert(t('account.groupNotFound'));
                    }
                } else {
                    alert(t('account.codeNoGroup'));
                }
            }
        } else {
            // No invitation found... try a group code
            const queryGroup = query(collection(db, "groups"), where("code", "==", this.group_code));
            const groupSnapshot = await getDocs(queryGroup);
            if (groupSnapshot.size > 0) {
                groupSnapshot.forEach((doc) => {
                    console.log(doc.id, ' => ', doc.data());
                    groupx = doc.data();
                });
            } else {
                alert(t('account.codeNoMatch'));
            }
        }

        if (groupx) {
            console.log(groupx);
            try {
                if (invitation && invitation.code) {
                    // Personal invitation: redeemed server-side (see
                    // claimInvitation), because a role invitation changes
                    // `role`, which the profile's own rules refuse.
                    await this.claimInvitationCode(invitation.code);
                } else {
                    // SET USER GROUPS (ARRAY) TO INCLUDE REGISTERED GROUP
                    if (this.user_profile.groups) {
                        if (!this.user_profile.groups.includes(groupx.uuid)) {
                            this.user_profile.groups.push(groupx.uuid);
                        }
                    } else {
                        this.user_profile.groups = [];
                        this.user_profile.groups.push(groupx.uuid);
                    }
                    // No invitation matched the code, so this must be a
                    // group code -- create the invitation server-side, since
                    // Firestore rules only allow a signed-in user to update
                    // an invitation they already own, not create a new one.
                    try {
                        const claimGroupInvitation = httpsCallable(functions, 'claimGroupInvitation');
                        await claimGroupInvitation({ group_uuid: groupx.uuid });
                    } catch (error) {
                    console.error('Error creating/updating invitation:', error);
                    }
                    // UPDATE USER TO SET REGISTERED GROUP
                    await setDoc(doc(db, "users", this.user_profile.email), this.user_profile, { merge: true });
                }
            } catch (err) {
                console.log(err);
                alert(this.claimErrorMessage(err));
                return;
            }
            // Need to reprocess group?
            if (this.report) {
                try {
                    groupx.status = 'process';
                    await setDoc(doc(db, "groups", groupx.uuid), groupx, { merge: true });
                } catch (err) {
                    console.log(err);
                }                
            }
            alert(t('account.addedToGroup'))
        }      
    }

    async getRegistrationGroup() {
        if (!this.user_profile.email) this.user_profile.email = user.email;
        this.group = undefined;
        // Get the invitation from code
        const invitationQuery = query(collectionGroup(db, 'invitations'), where("code", "==", this.group_code));
        const invitationSnapshot = await getDocs(invitationQuery);
        let invitation = {};
        // An invitation was found
        if (invitationSnapshot.size > 0) {
            // @TODO throw error if size > 1
            
            // this is getting the last invitation
            invitationSnapshot.forEach((invDoc) => {
                console.log(invDoc.id, ' => ', invDoc.data());
                invitation = invDoc.data();
            });
            if (invitation.status && invitation.status == "claimed") {
                alert(t('account.codeClaimed'));
            } else {
                // Get the group for the invitation
                if (invitation.group_uuid) {
                    const groupRef = doc(db, "groups", invitation.group_uuid);
                    const groupSnap = await getDoc(groupRef);
                    if (groupSnap.exists()) {
                        console.log(groupSnap.id, ' => ', groupSnap.data());
                        this.group = groupSnap.data(); 
                    } else {
                        alert(t('account.groupNotFound'));
                    }
                } else {
                    alert(t('account.codeNoGroup'));
                }
            }
        } else {
            // No invitation found... try a group code
            const queryGroup = query(collection(db, "groups"), where("code", "==", this.group_code));
            const groupSnapshot = await getDocs(queryGroup);
            if (groupSnapshot.size > 0) {
                groupSnapshot.forEach((doc) => {
                    console.log(doc.id, ' => ', doc.data());
                    this.group = doc.data();
                });
            } else {
                alert(t('account.codeNoMatch'));
            }
        }
        // PROBABLY SHOULD NOT SET THIS.GROUP UNTIL HAVE UPDATED USER_PROFILE.GROUP AND
        // SAVED IT
        if (this.group) {
            console.log(this.group);
            try {
                if (invitation && invitation.code) {
                    // Personal invitation: redeemed server-side (see
                    // claimInvitation), because a role invitation changes
                    // `role`, which the profile's own rules refuse.
                    await this.claimInvitationCode(invitation.code);
                } else {
                    if (!this.user_profile.group) {
                        this.user_profile.group = this.group.uuid;
                    };

                    // SET USER GROUPS (ARRAY) TO INCLUDE REGISTERED GROUP
                    if (this.user_profile.groups) {
                        if (!this.user_profile.groups.includes(this.group.uuid)) {
                            this.user_profile.groups.push(this.group.uuid);
                        }
                    } else {
                        this.user_profile.groups = [];
                        this.user_profile.groups.push(this.group.uuid);
                    }
                    if (this.group.payment_amount < 0.01) {
                        this.user_profile.paid = true;
                        this.user_profile.paid_date = new Date().toISOString();
                        this.user_profile.paid_group = this.group.uuid;
                    }
                    // No invitation matched the code, so this must be a
                    // group code -- create the invitation server-side, since
                    // Firestore rules only allow a signed-in user to update
                    // an invitation they already own, not create a new one.
                    try {
                        const claimGroupInvitation = httpsCallable(functions, 'claimGroupInvitation');
                        await claimGroupInvitation({ group_uuid: this.group.uuid });
                    } catch (error) {
                    console.error('Error creating/updating invitation:', error);
                    }
                    // UPDATE USER TO SET REGISTERED GROUP
                    await setDoc(doc(db, "users", this.user_profile.email), this.user_profile, { merge: true });
                }
            } catch (err) {
                console.log(err);
                this.group = undefined;
                alert(this.claimErrorMessage(err));
                return;
            }
            // Need to reprocess group?
            if (this.report) {
                try {
                    this.group.status = 'process';
                    await setDoc(doc(db, "groups", this.group.uuid), this.group, { merge: true });
                } catch (err) {
                    console.log(err);
                }                
            }
        }      
    }
    
    async gotoPayment(e) {
        const startPayment = httpsCallable(functions, 'startPayment');
        this.started_payment = true;
        // Passing the currently-displayed profile's email, not necessarily
        // the signed-in identity: while masquerading, request.auth still
        // names the real staff member, so the function needs telling who to
        // actually act on. Harmless when not masquerading -- it's just the
        // caller's own email either way.
        startPayment({ text: 'messageText', targetEmail: this.user_profile.email })
        .then((result) => {
          const data = result.data;
          if (data.href) {
              window.location = data.href;
          } else {
              alert(t('account.paymentGatewayError'));
          }
        });
    }

    async startPayment(e) {
      try {
        // call your cloud function to create session (wait for it)
        const startPayment = httpsCallable(functions, "startStripePayment");
        const result = await startPayment({ text: "messageText", targetEmail: this.user_profile.email });
        window.location = result.data.url;

      } catch (err) {
        console.error("startPayment error:", err);
        alert(t('account.paymentStartFailed', { message: err.message || t('common.unknownError') }));
      }
    }
    
    render() {
        return html`
            <h1 class="sr-only">${t('account.heading')}</h1>
            <div class="user_layout">

                <div style="margin-left: 20px;">
                    <img alt="" style="width: ${window.innerWidth < 600 ? '100px': '170px'}; height: ${window.innerWidth < 600 ? '100px': '170px'};" src="${this.user_profile.image}" />
                    <user-profile-field-editor .user_profile=${this.user_profile} field="image" .value=${this.user_profile.image}></user-profile-field-editor>
                </div>
        
                <div style="width: 100%;">
                    <div class="user_field">
                        ${this.user_profile.displayName}
                        <span class="user_edit">${t('account.editName')}</span>
                    </div>
                    <div class="user_field">
                        ${this.user_profile.email}
                    </div>
                    <div class="user_field">
                        <div>
                            <user-profile-field-editor show_value="true" .user_profile=${this.user_profile} field="organization" .value=${this.user_profile.organization}></user-profile-field-editor>
                        </div>
                        <div>
                            <user-profile-field-editor show_value="true" .user_profile=${this.user_profile} field="title" .value=${this.user_profile.title}></user-profile-field-editor>
                        </div>
                    </div>
                </div>
        
                ${this.user_profile.paid ? html`
                <button type="button" class="unstyled-button" style="text-align: center; margin-right: 20px;" @click=${(e) => {
                    if (this.report) {
                        if (confirm(t('account.confirmBadgeDownload'))) {
                            const badge = e.currentTarget.querySelector('intrivity-badge');
                            htmlToImage.toPng(badge)
                                .then(function (dataUrl) {
                                    var link = document.createElement('a');
                                    link.download = 'mrts-badge.png';
                                    link.href = dataUrl;
                                    link.click();
                                });
                        }
                    }
                }}>
                <span class="sr-only">${t('account.downloadBadge')}</span>
                <intrivity-badge aria-hidden="true" style="aspect-ratio: 1; text-align: center;" size="${window.innerWidth < 600 ? '1': '1.7'}" m="${this.report ? getScore(this.report.m.average): -1}" r="${this.report ? getScore(this.report.r.average): -2}" t="${this.report ? getScore(this.report.t.average): -3}" s="${this.report ? getScore(this.report.s.average): -4}" type="square"></intrivity-badge>
                </button>
                `: html``}

                ${ this.user_profile.group ? html`
                    ${ this.user_profile.paid ? html``: html`
                        <div class="user_config">
                                <div>${t('account.assessmentReport')}
                                    ${this.group ? t('account.fee', { amount: formatNumber(this.group.payment_amount < 0.01 ? 0 : Number(this.group.payment_amount), { style: 'currency', currency: 'USD' }) }) : html``}
                                ${this.group ? html`<mwc-button .disabled=${this.started_payment} style="vertical-align: bottom;" outlined dense @click=${this.startPayment}>${this.group.payment_amount < 0.01 ? t('account.activateFree') : t('account.submitPayment')}</mwc-button>`: html``}</div>                                 
                        </div>
                    `}              
        
                    ${this.report ? html`
                        <div class="user_config">
                            <div>
                                ${t('account.additionalCode')}
                            </div> 
                            <div>
                                <mwc-textfield @change=${(e) => { this.group_code = e.target.value; } } label=${t('account.codeLabel')}></mwc-textfield>
                                <mwc-button style="vertical-align: bottom;" outlined dense @click=${this.getAdditionalGroup}>${t('common.submit')}</mwc-button>
                            </div>
                        </div>                        
                    `: html`
                        <div class="user_config">
                            ${this.user_profile.processing && this.user_profile["processing"] == true ? html`
                                <div>${t('account.surveyProcessing')}</div>
                            `: html`
                                <mwc-button style="vertical-align: bottom;" outlined dense @click=${this.sendToSurvey}>${t('account.takeAssessment')}</mwc-button>
                            `}                    
                        </div>
                    `}
                    
                `: html`
                    <div class="user_config">
                        <div>${t('account.noGroup')}</div>
                        <div>
                            ${t('account.enterCode')}
                        </div> 
                        <div>
                            <mwc-textfield @change=${(e) => { this.group_code = e.target.value; } } label=${t('account.codeLabel')}></mwc-textfield>
                            <mwc-button style="vertical-align: bottom;" outlined dense @click=${this.getRegistrationGroup}>${t('common.submit')}</mwc-button>
                        </div>
                    </div>
                `}
                

            </div>
            <mwc-dialog class="groupDialog" scrimClickAction="">
        
                ${this.display_group ? html`
                <h2 style="font-weight: normal; margin: 0; font-size: larger;">${this.display_group.title ? this.display_group.title: ''}</h2>
                <div style="font-size: smaller">${t('account.teamSize', { count: this.display_group.users.length })}</div>
        
                <table style="margin-top: 20px; width: 100%; border-collapse: collapse;">
                    <caption class="sr-only">${this.display_group.title ? t('account.membersOf', { title: this.display_group.title }) : t('account.membersOfThisGroup')}</caption>
                    <thead>
                        <tr>
                            <th scope="col"><span class="sr-only">${t('account.photo')}</span></th>
                            <th scope="col" style="text-align: left;">${t('common.lastName')}</th>
                            <th scope="col" style="text-align: left;">${t('common.firstName')}</th>
                            <th scope="col" style="text-align: left;">${t('common.title')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${this.display_group.users.map((user) => html`
                            <tr>
                                <td style="text-align: center;">
                                    ${user.image ? html`<img alt="" src=${user.image} width="40px" />`: html``}
                                </td>
                                <td style="font-size: smaller">${user.lastName ? user.lastName: ''}</td>
                                <td style="font-size: smaller">${user.firstName ? user.firstName: ''}</td>
                                <td style="font-size: smaller">${user.title ? user.title: ''}</td>
                            </tr>
                        `)}
                    </tbody>
                </table>
                
                <div style="width: 100%; text-align: center;">
                    <div style="cursor: pointer; padding: 5px; padding-left: 15px; padding-right: 15px; font-weight: bolder; display: inline; background-color: rgb(80, 120, 123); color: white; margin-top: 10px;">${t('account.goToTeam')}</div>
                </div>
        
                `: html`` }
            </mwc-dialog>
        `
    } 
 
}
if (!customElements.get('intrivity-user')) customElements.define('intrivity-user', IntrivityUserApp);
